export const VUMA_KEY_SUBURB = 'ALEXANDRA'
export const VUMA_KEY_POSTAL_CODE = '2090'
export const VUMA_BUSINESS_FEASIBILITY_API_KEY = 'IOwl6Gwh9NG63fZPa1EL2JaDvXbNqf1O'